// Module
var code = "<tr class=offerRow> <td colspan=10 class=text-center> No offers results found </td> </tr> ";
// Exports
module.exports = code;